/* AUTAVEX — екошкіра: ціни та варіанти [Comfort, Premium]
   'ask' — ціну уточнює менеджер */
window.AV_EK={
 V:{
  front:[46347279630472,46347281301640],
  full:[46347281236104,46347281334408],
  trunk:[46347281268872,46347281367176],
  mini:[46347302338696,46347302437000],
  row3:[46347302371464,46347346509960],
  bus:[46347302404232,46347302469768],
  logo:46279958462600,
  heel:46279958495368
 },
 PR:{
  B:{front:[1750,1950],full:[3950,5500],trunk:[2950,4800],mini:null,row3:null,bus:null},
  C:{front:[1750,1950],full:[3950,5500],trunk:[2950,4800],mini:null,row3:[1550,2500],bus:null},
  P:{front:[1750,1950],full:[3950,5500],trunk:[2950,4800],mini:null,row3:null,bus:null},
  M:{front:[1750,1950],full:null,trunk:[2950,4800],mini:[6950,'ask'],row3:[1550,2500],bus:null},
  F:{front:null,full:null,trunk:null,mini:null,row3:null,bus:[3750,'ask']}
 }
};
/* третій ряд — лише якщо є в базі (індекс 6 у рядку авто) */
window.AV_HAS_ROW3=function(st,DB){
  if(!DB||!DB.brands||!st||!st.brand||!st.model||!st.body||!st.year)return false;
  var rows=DB.brands[st.brand]||[];
  for(var i=0;i<rows.length;i++){
    var r=rows[i];
    if(r[0]===st.model&&r[1]===st.body&&st.year>=r[2]&&st.year<=r[3])return !!r[6];
  }
  return false;
};
